import ReactTooltip, { Effect, GetContent, Offset, Place } from "react-tooltip";

type TooltipPropsType = {
  id: string;
  className?: string;
  effect?: Effect;
  place?: Place;
  ariaHasPopup?: string;
  afterShow?: () => void;
  getContent?: GetContent;
  offset?: Offset;
  /** Keep tooltip open when hovering its content (e.g. scrollable lists). */
  clickable?: boolean;
  delayHide?: number;
};

// Keyed on the `place-*` class react-tooltip puts on the element, not on the
// `place` prop: the library flips the tooltip to another side when it would
// overflow the viewport, and the arrow has to follow the side it actually
// landed on.
const PLACEMENT_STYLES = [
  "[&.place-top]:after:!-bottom-2xs",
  "[&.place-bottom]:after:!-top-2xs",
  "[&.place-left]:after:!-right-2xs [&.place-left]:after:!-mt-[3px]",
  "[&.place-right]:after:!-left-2xs [&.place-right]:after:!-mt-[3px]",
].join(" ");

const Tooltip = ({
  id,
  className = "",
  effect = "solid",
  place = "bottom",
  ariaHasPopup = "",
  afterShow = () => {},
  getContent = null,
  offset = null,
  clickable = false,
  delayHide,
}: TooltipPropsType) => {
  return (
    <ReactTooltip
      id={id}
      className={`!px-sm !py-2xs !font-manrope !text-xs !font-medium !text-inverse !bg-secondary !rounded-md !opacity-100 after:!w-xs after:!h-xs after:!bg-secondary after:!rounded-[1px] before:hidden ${PLACEMENT_STYLES} ${className}`}
      effect={effect}
      place={place}
      afterShow={afterShow}
      aria-haspopup={ariaHasPopup}
      getContent={getContent}
      offset={offset}
      clickable={clickable}
      delayHide={delayHide}
    />
  );
};

export default Tooltip;
